import React, { ReactElement, ReactNode, useCallback } from 'react';
import cx from 'classnames';

import ArticlesTagsOptionCheckIcon from '../ArticlesTagsOptionCheckIcon';
import styles from './ArticlesTagsOptionItem.module.scss';

interface IArticlesTagsOptionItemProps {
  className?: string;
  children?: ReactNode;
  selected: boolean;
  tag: string;
  onSelect: (key: string) => void;
}

const ArticlesTagsOptionItem = ({
  children,
  className,
  selected,
  tag,
  onSelect
}: IArticlesTagsOptionItemProps): ReactElement => {
  const handleClick = useCallback(() => {
    onSelect(tag);
  }, [tag, onSelect]);

  return (
    <div className={cx(styles.container, className)} onClick={handleClick}>
      <ArticlesTagsOptionCheckIcon className={styles.iconContainer} checked={selected} />
      {children}
    </div>
  );
};

export default ArticlesTagsOptionItem;
